import { Provider } from '@angular/core';

import { FolderStore } from '../api-folders/folder-store';
import { FolderStoreService } from './folder-store.service';

export const FOLDER_PROVIDERS: Provider[] = [{ provide: FolderStore, useClass: FolderStoreService }];
